import { Component } from "../bootstrap/component";
import { BrowserComponent } from "../app";

interface IStickyService {
  elements: NodeListOf<HTMLElement>
}

export class StickyService extends Component implements IStickyService {
  elements: NodeListOf<HTMLElement>;
  data: Array<{
    offsetTop: number;
    isActive: boolean;
    height: number;
    element: HTMLElement;
    index: number;
  }>;

  constructor(params: IStickyService) {
    super(params);
  }

  public onInit() {
    if (!this.elements.length) {
      return false;
    }

    this.onResize();
  }

  public onResize() {
    this.recalculateData();
    this.onScroll();
  }

  public onScroll() {
    this.data.forEach((data, index) => {
      const { offsetTop, isActive, element } = data;

      const prevHeight = this.data
        .filter(value => value.index < index && value.isActive)
        .reduce((previousValue, currentValue) => {
          return previousValue + currentValue.height;
        }, 0);

      if (BrowserComponent.scroll.top > offsetTop - prevHeight) {
        if (!isActive) {

          const parent = element.parentElement;
          const { offsetLeft, offsetWidth } = parent;

          data.isActive = true;

          const styles: Partial<CSSStyleDeclaration> = {
            top: `${prevHeight}px`,
            left: `${offsetLeft}px`,
            width: `${offsetWidth}px`
          }
          Object.assign(element.style, styles);

          element.parentElement.classList.add(`isSticky`);
        }
      } else if (isActive) {
        data.isActive = false;

        const styles: Partial<CSSStyleDeclaration> = {
          top: null,
          left: null,
          width: null
        }

        Object.assign(element.style, styles);
        element.parentElement.classList.remove(`isSticky`);
      }
    });
  }

  public recalculateData() {
    this.data = [];

    this.elements.forEach((element, index) => {
      const disabledViewport = element.dataset['stickydisabled'];

      if (disabledViewport && window.matchMedia(`(${disabledViewport})`).matches) {
        return;
      }

      const parent = element.parentElement;
      const offsetTop = parent.offsetTop;
      const height = parent.scrollHeight;

      this.data.push({
        offsetTop,
        element,
        height,
        index,
        isActive: false
      });
    });
  }
}